// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1018":"80eec3becf99058a","1646":"46aeee2c95737391","2515":"131c9af6aee892cc","7769":"54e0f4df979a9574","8116":"1b43d93de521f973"}[chunkId] + ".css";
};